import { useTranslation } from "react-i18next";
function General() {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow p-6">
      <h2 className="text-lg font-semibold mb-4">
        {t("admin.tenantDetails.content.generalInfo.title")}
      </h2>
      <p className="text-gray-600">
        {t("admin.tenantDetails.content.generalInfo.description")}
      </p>
    </div>
  );
}

export default General;
